export enum PaymentTrackEventName {
  PaymentTimeout = 'Payment Timeout',
  PaymentRetry = 'Payment Retry',
  PaymentInitiated = 'Payment Initiated',
  PaymentSucceeded = 'Payment Succeeded',
  PaymentFailed = 'Payment Failed',
}

export type PaymentPurchaseType =
  | 'order'
  | 'member_money_topup'
  | 'giftcard_purchase'
  | 'giftcard_topup';

export type PaymentFailureReason =
  | 'payment_session_failed'
  | 'charge_request_failed'
  | 'redcat_payment_failed'
  | 'redcat_payment_error'
  | 'redcat_payment_not_authorised'
  | 'session_reference_missing';

export interface PaymentEventBase {
  purchaseType?: PaymentPurchaseType;
  memberId?: string | null;
  transactionId?: string | null;
}

export interface PaymentEventProperties {
  purchase_type?: PaymentPurchaseType;
  member_id?: string;
  transaction_id?: string;
}
